import React from 'react';
import './TopBar.less';
import { Row, Item } from 'react-plan';
import { Link } from 'react-router';

type Props = {

}

const strings = {
  title: 'WORLD SPACE SCHOOL',
  about: 'About',
  courses: 'Courses',
  news: 'News',
  //contact: 'Contact',
  login: 'Login'
};

class TopBar extends React.Component {

  description: 'The top sitewide bar.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <Row
        align="center"
        className="top-bar"
        justify="space-between"
      >
        <Item className="logo" small="100%">
          <Link to="/"><h3 className="logo-typo">{ strings.title }</h3></Link>
        </Item>
        <Row
          align="stretch"
          className="links"
          justify="flex-end"
          small="100%"
        >
          <Link activeClassName="active" to="/about"><span>{ strings.about }</span></Link>
          <Link activeClassName="active" to="/courses"><span>{ strings.courses }</span></Link>
          <Link activeClassName="active" to="/news"><span>{ strings.news }</span></Link>
          {/*<Link activeClassName="active" className="cacher" to="/contact"><span>{ strings.contact }</span></Link>*/ }
        </Row>
      </Row>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default TopBar;

//Unit test entry point
export const TopBarTest = TopBar;



/** WEBPACK FOOTER **
 ** ./src/js/app/TopBar/TopBar.jsx
 **/